/**
 * The ONE region-routing config, shared by the REST `ApiClient` and the private-
 * api GraphQL client.
 *
 * Both transports must resolve the caller's active region IDENTICALLY — the
 * `region_alias` + `continent` from the JWT, the `_use_region_alias` manual pin,
 * and the minute-based failover — so a region switch (or failover) moves REST
 * and GraphQL together. Keeping the `RegionRoutingConfig` here (not inlined in
 * each client) is what guarantees they can't drift, reading the same live token
 * snapshot from {@link getRoutingToken}.
 */
import type { RegionRoutingConfig } from "@authe/fe-commons/api";
import { appEnv, APPLICATION_SLUG } from "@/config";
import { getRoutingToken } from "./routing-token";

export const regionRoutingConfig: RegionRoutingConfig = {
  sourcePlatform: APPLICATION_SLUG,
  claimsNamespace: appEnv.claimsNamespace,
  apiBaseDomain: appEnv.apiBaseDomain,
  env: appEnv.env,
  localStoragePrefixPlatform: APPLICATION_SLUG.toUpperCase(),
  getToken: getRoutingToken,
};
